/**
 * Copyright (c) 2026 Accunai India Services Pvt. Ltd. All rights reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 *
 * This file is part of proprietary software owned by Accunai India Services Pvt. Ltd.
 * Unauthorized copying, distribution, modification, or use of this file,
 * in whole or in part, via any medium, is strictly prohibited without
 * prior written permission from Accunai India Services Pvt. Ltd.
 *
 * Generated with GitHub Copilot Business/Enterprise.
 * Reviewed and approved by: AI-assisted / 2026-07-13
 */

import React from "react";
import { Link } from "react-router-dom";
import logo from "assets/img/fsl_logo.png";
import "../styles/common.css";

type Props = {
  width?: number;
};

const Logo: React.FC<Props> = ({ width }) => {
  const imgWidth = width ?? 130;

  return (
    <Link to="/" className="shared-logo-link">
      <section className="shared-logo-wrap">
        <img src={logo} alt="FSL logo" width={imgWidth} className="shared-logo-image" />
      </section>
    </Link>
  );
};

export default Logo;
